/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SkinsbackDeposit = {
    /**
     * Deposit ID
     */
    id?: string;
    /**
     * User ID
     */
    userId?: string;
    /**
     * Skinsback transaction ID
     */
    transactionId?: number;
    /**
     * Internal order ID
     */
    orderId?: string;
    /**
     * Steam trade offer ID
     */
    tradeOfferId?: string | null;
    /**
     * Original deposit amount in cents
     */
    sum?: number;
    /**
     * Applied bonus multiplier
     */
    bonusMultiplier?: number;
    /**
     * Total amount including bonus in cents
     */
    sumWithBonusAmount?: number;
    /**
     * Amount credited instantly in cents
     */
    instantCreditAmount?: number;
    /**
     * Flag to track if instant credit was applied
     */
    instantCreditGiven?: boolean;
    /**
     * Remaining amount to credit after hold period
     */
    remainingCreditAmount?: number;
    /**
     * Flag to track if remaining credit was given
     */
    remainingCreditGiven?: boolean;
    /**
     * Deposit status
     */
    status?: SkinsbackDeposit.status;
    /**
     * Array of Steam asset IDs
     */
    assetIds?: Array<string>;
    /**
     * Risk level for instant credit
     */
    riskLevel?: SkinsbackDeposit.riskLevel;
    /**
     * Risk percentage for instant credit
     */
    riskPercent?: number;
    /**
     * Risk fixed amount for instant credit
     */
    riskAmount?: number;
    /**
     * Risk maximum amount for instant credit
     */
    riskMaxAmount?: number;
    /**
     * Full Skinsback API response
     */
    rawResponse?: Record<string, any> | null;
    /**
     * Creation timestamp
     */
    createdAt?: string;
    /**
     * Last update timestamp
     */
    updatedAt?: string;
    /**
     * User Steam ID (from join)
     */
    userSteamId?: string;
    /**
     * User name (from join)
     */
    userName?: string;
    /**
     * User avatar URL (from join)
     */
    userAvatar?: string;
};
export namespace SkinsbackDeposit {
    /**
     * Deposit status
     */
    export enum status {
        PENDING = 'pending',
        IN_HOLD = 'in_hold',
        SUCCESS = 'success',
        FAIL = 'fail',
        HOLD_APPROVED = 'hold_approved',
        HOLD_RETURNED = 'hold_returned',
    }
    /**
     * Risk level for instant credit
     */
    export enum riskLevel {
        LOW = 'low',
        HIGH = 'high',
        VIP = 'vip',
    }
}

